<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="120">
      <FormItem label="企业名称" prop="companyName">
        <Input v-model="form.companyName" :maxlength="128"></Input>
      </FormItem>
      <FormItem label="企业简称" prop="shortName">
        <Input v-model="form.shortName" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="上级企业" prop="parentId">
        <sl-select v-if="isAdmin" v-model="form.parentId" dict="company" :exclude-options="disableOptions" :filterable="true"></sl-select>
        <span v-if="!isAdmin">{{data.parentName}}</span>
      </FormItem>
      <FormItem label="统一信用代码" prop="unionCreditCode">
        <Input v-model="form.unionCreditCode" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="运营方式" prop="runType">
        <sl-select v-model="form.runType" type="select" dict="runType"></sl-select>
      </FormItem>
      <FormItem label="企业类型" prop="companyType">
        <sl-select v-model="form.companyType" type="select" dict="$companyType"></sl-select>
      </FormItem>
      <FormItem label="企业性质" prop="companyNature">
        <sl-select v-model="form.companyNature" type="select" dict="$companyNature"></sl-select>
      </FormItem>
      <FormItem label="负责人" prop="legalName">
        <Input v-model="form.legalName" :maxlength="32"></Input>
      </FormItem>
      <FormItem label="联系电话" prop="companyPhone">
        <Input v-model="form.companyPhone" :maxlength="16"></Input>
      </FormItem>
      <FormItem label="存量车整改数量" prop="storageCount" :rules="storageCountRules">
        <InputNumber v-model="form.storageCount" :min="0" :step="1" :parser="v => v.replace(/[^\d]/g, '')" :active-change="true" />
      </FormItem>
      <FormItem label="品牌" prop="brandId">
        <sl-select v-model="form.brandId"  type="select" dict="brand"></sl-select>
      </FormItem>
      <FormItem label="所属区域" prop="districtCode">
        <sl-area v-model="form.districtCode" :level="3" @change-data="handleAreaChange" />
      </FormItem>
      <FormItem label="成立时间" prop="establishDatetime">
        <DatePicker type="date" v-model="form.establishDatetime"></DatePicker>
      </FormItem>
      <FormItem label="注册地址" prop="regAddress">
        <Input v-model="form.regAddress" :maxlength="128"></Input>
      </FormItem>
      <FormItem label="经营地址" prop="businessAddress">
        <Input v-model="form.businessAddress" :maxlength="128"></Input>
      </FormItem>
      <FormItem label="地理位置" prop="location">
        <sl-amap style="height:260px;">
          <sl-amap-location ref="locationPicker" v-model="form.location" cs="wgs84"></sl-amap-location>
          <sl-amap-fullscreen />
        </sl-amap>
      </FormItem>
      <FormItem label="网点照片">
        <sl-upload :public="true" style="margin-top:8px;" v-model="state.photo21.value" :type="21" :limit="6">支持格式：jpg, png, bmp , gif。最多6张</sl-upload>
      </FormItem>
      <FormItem label="备案申请表">
        <sl-upload :public="true" style="margin-top:8px;" v-model="state.photo22.value" :type="22" :limit="1">支持格式：jpg, png, bmp , gif。</sl-upload>
      </FormItem>
      <FormItem label="营业执照">
        <sl-upload :public="true" style="margin-top:8px;" v-model="state.photo23.value" :type="23" :limit="1">支持格式：jpg, png, bmp , gif。</sl-upload>
      </FormItem>
      <FormItem label="负责人身份证正面">
        <sl-upload :public="true" style="margin-top:8px;" v-model="state.photo24.value" :type="24" :limit="1">支持格式：jpg, png, bmp , gif。</sl-upload>
      </FormItem>
      <FormItem label="负责人身份证背面">
        <sl-upload :public="true" style="margin-top:8px;" v-model="state.photo25.value" :type="25" :limit="1">支持格式：jpg, png, bmp , gif。</sl-upload>
      </FormItem>
      <FormItem label="快递经营许可证">
        <sl-upload :public="true" style="margin-top:8px;" v-model="state.photo26.value" :type="26" :limit="1">支持格式：jpg, png, bmp , gif。</sl-upload>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.remark"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
import { phoneValidator, emptyValidator } from '@/util/validator'
import { wgs2gcj, gcj2wgs } from '@/util/map/proj'
import global from '@/util/mixin/global'

export default {
  mixins:[global],
  data() {
    return {
      rules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur,change' },
        ],
        legalName: [
          { required: true, message: '请输入联系人', trigger: 'blur,change' },
        ],
        companyPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur,change' },
          { validator: phoneValidator('请输入手机号', '请输入正确格式的手机号'), trigger: 'blur,change' },
        ],
        businessAddress:[
          { required: true, message: '请输入经营地址', trigger: 'blur,change' },
        ],
        // unionCreditCode: [
        //   { required: false, message: '请输入统一信用代码', trigger: 'blur,change' },
        // ],
        // companyType: [
        //   { type: 'number', required: true, message: '请选择企业类型', trigger: 'blur,change' },
        // ],
        // companyNature: [
        //   { type: 'number', required: true, message: '请选择企业性质', trigger: 'blur,change' },
        // ],
        brandId: [
          { type: 'number', required: true, message: '请选择品牌', trigger: 'blur,change' },
        ],
        districtCode: [
          { required: true, message:'请选择区域', trigger: 'blur,change' }
        ],
        
        location:[
          { required: true, validator: emptyValidator('请指定企业位置', 'array'), trigger: 'blur,change' }
        ],

        // regName: [
        //   { required: true, message: '请输入注册人姓名', trigger: 'blur,change' },
        // ],
        // regIdNo: [
        //   { required: true, message: '请输入注册人身份证号', trigger: 'blur,change' },
        // ],
        // legalName: [
        //   { required: true, message: '请输入法人电话', trigger: 'blur,change' },
        // ],
        // legalMobile: [
        //   { required: true, message: '请输入法人电话', trigger: 'blur,change' },
        // ],
      },
      def: {},
      form: {
        id: null,
        shortName: null,
        companyName: null,
        legalName: null,
        brandId: null,
        companyPhone: null,
        companyType: null,
        companyNature: null,
        unionCreditCode: null,
        businessAddress: null,
        regAddress: null,
        parentId: null,
        remark: null,
        province: null,
        city: null,
        area: null,
        runType:null,
        districtCode:null,
        storageCount:null,
        location: []
      },
      state:{
        photo21:{limit:6 , value:[]},
        photo22:{limit:1 , value:null},
        photo23:{limit:1 , value:null},
        photo24:{limit:1 , value:null},
        photo25:{limit:1 , value:null},
        photo26:{limit:1 , value:null},
      },
      id: null,
      loading: false,
      isCreate: true,
      brands: [],
      area: [],
      type: null,
      modalVisible: false,
      data:{}
    }
  },

  computed: {
    itemTitle() {
      return (this.id ? '编辑' : '新增') + (this.type == 1 ? '网点' : '企业')
    },
    companyChangeMode(){
      return this.id && this.isCompany
    },
    storageCountRules(){
      return [
          { type: 'number', required: this.isCompany, message: '请输入存量车整改数量', trigger: 'blur,change' },
      ]
    },
    disableOptions(){
      return [this.id]
    }
  },
  created() {
    this.def = { ...this.form }
    // this.$request.brands(0).then(resp => {
    //   if (resp.data) {
    //     this.brands = resp.data.map(i => ({ value: i.id, label: i.brandShortName }))
    //   }
    // })
    this.prepare()
  },

  methods: {
    prepare() {

    },

    init(id) {
      this.id = id
      this.reset()
      this.modalVisible = true
      //this.$refs['mapLocation'].clear()
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.company(this.id).then(resp => {
        this.$utils.fill(this.form, resp.data)
        if (resp.data.latitude && resp.data.longitude) {
          this.form.location = [resp.data.longitude , resp.data.latitude]
        }
        if(resp.data.establishDatetime){
          this.form.establishDatetime = new Date(resp.data.establishDatetime)
        }
        if( resp.data.files ){
          let state = this.state
          for(let i in state){
            let fileType = i.replace('photo','') 
            let files = resp.data.files.filter(i => i.fileType == fileType).map(i => i.filePath)
            if(state[i].limit == 1){
              state['photo'+fileType]['value'] = files[0]
            }else{
              state['photo'+fileType]['value'] = files
            }
          }
        }
        this.data = resp.data
      })

    },

    reset() {
      this.$utils.fill(this.form, this.def)
      this.$refs['form'].resetFields()
      this.data = {}
      this.$refs['locationPicker'].clear()
      for(let i in this.state){
        if(this.state[i].limit == 1) this.state[i].value = null
        else this.state[i].value = []
      }
    },

    save() {
      //
      let params = { ...this.form }
      
      params.latitude = this.form.location[1]
      params.longitude = this.form.location[0]
      delete params.location

      let state = this.state
      let files = []
      for(let i in state){
        let fileType = parseInt(i.replace('photo',''))

        if(state[i].limit == 1){
          if(state[i].value){
            files.push({
              fileType , filePath:state[i].value
            })
          }
        }else{
          for(let j of state[i].value){
            files.push({
              fileType , filePath:j
            })
          }            
        }
      }

      params.files = files

      this.loading = true
      let companyChangeMode = this.companyChangeMode
      let promise = this.id ? this.$request.companyUpdate : this.$request.companyCreate

      if( companyChangeMode ) promise = this.$request.companyChange

      promise(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          if( companyChangeMode ){
            this.$Modal.success({
              title: '提交成功',
              content: '待系统审核通过后，信息将会更新！',
              onOk:()=>{
                this.modalVisible = false
              }
            });
          }else{
            this.$Message.success('保存成功')
            this.modalVisible = false
          }
          this.$emit('update')
          if (!this.id) {
            this.prepare()
          }
          

        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    },
    handleAreaChange(data){
      this.$utils.areaSet(this.form , data.map(i => i.name))
    },
    handlePositionChange(data) {
      console.log(data)
    }
  }
}

</script>
